import React from 'react';
import { Modal, Box, Button } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import {
    formatTrailAmount,
    formatTrailRemarks,
    getTrailRemarksTitle,
    getTrailStepStatus,
} from './reconPaymentHelpers';

const PaymentTrailModal = ({ open, onClose, trails = [] }) => (
    <Modal open={open} onClose={onClose} aria-labelledby="payment-trail-modal">
        <Box
            sx={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                backgroundColor: 'white',
                borderRadius: '8px',
                boxShadow: 24,
                padding: '24px',
                maxWidth: '900px',
                width: '90%',
                maxHeight: '80vh',
                overflowY: 'auto',
            }}
        >
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    marginBottom: '16px',
                }}
            >
                <h2 id="payment-trail-modal" style={{ margin: 0 }}>
                    Payment Trail Details
                </h2>
                <Button onClick={onClose} sx={{ minWidth: 'auto', padding: 0 }}>
                    <CloseIcon />
                </Button>
            </Box>

            <table style={{ width: '100%', borderCollapse: 'collapse' }}>
                <thead>
                    <tr
                        style={{
                            borderBottom: '2px solid #ddd',
                            background: '#000',
                            color: '#fff',
                        }}
                    >
                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>
                            Transaction ID
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>
                            Date
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>
                            Amount
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>
                            Status
                        </th>
                        <th style={{ padding: '12px', textAlign: 'left', fontWeight: 'bold' }}>
                            Remarks
                        </th>
                    </tr>
                </thead>
                <tbody>
                    {trails.length > 0 ? (
                        trails.map((trail, index) => {
                            const statusMeta = getTrailStepStatus(trail, index);
                            return (
                                <tr
                                    key={`trail_${trail.trail_stage || 'step'}_${trail.transaction_reference || 'notxn'}_${trail.created_at || 'nodate'}_${index}`}
                                    style={{ borderBottom: '1px solid #ddd' }}
                                >
                                    <td style={{ padding: '12px' }}>
                                        {trail.transaction_reference || 'N/A'}
                                    </td>
                                    <td style={{ padding: '12px' }}>
                                        {trail.created_at || 'N/A'}
                                    </td>
                                    <td style={{ padding: '12px' }}>
                                        {formatTrailAmount(trail.amount_paise)}
                                    </td>
                                    <td style={{ padding: '12px' }}>
                                        {statusMeta ? (
                                            <span
                                                style={{
                                                    padding: '4px 8px',
                                                    borderRadius: '4px',
                                                    backgroundColor: statusMeta.color,
                                                    color: statusMeta.textColor,
                                                }}
                                            >
                                                {statusMeta.label}
                                            </span>
                                        ) : (
                                            'N/A'
                                        )}
                                    </td>
                                    <td
                                        style={{ padding: '12px' }}
                                        title={getTrailRemarksTitle(trail)}
                                    >
                                        {formatTrailRemarks(trail, index)}
                                    </td>
                                </tr>
                            );
                        })
                    ) : (
                        <tr>
                            <td
                                colSpan="5"
                                style={{
                                    padding: '12px',
                                    textAlign: 'center',
                                    color: '#999',
                                }}
                            >
                                No payment trail data available
                            </td>
                        </tr>
                    )}
                </tbody>
            </table>
        </Box>
    </Modal>
);

export default PaymentTrailModal;
